export interface IQueryResult<T = unknown> {
    items: Array<T>;
    totalNumberOfResults: number;
    offset: number;
}
